const button = {
    cancel: 'Annuler',
    ok: 'OK',

    no: 'Non',
    yes: 'Oui',
    library: 'Bibliothèque',
    save: 'Sauvegarder',
};

export default button;
